import Base  from "../Base";
import axios from "axios";

const url = {
  index: "/api",
}

class Auth extends Base {

  static getComponents() {
    return {
      "signup"   : require("./Parts/SignupCard"),
      "register" : require("./Parts/RegisterForm"),
    };
  }

  static magicLink = async (data)=>
    (await axios.post(`${url.index}/register/magic-link`, data)).data;

  static google = async (data)=>
    (await axios.post('/api/register/google', data)).data;

  static register = async (data)=>
    (await axios.post('/api/register', data)).data;


  static autoDetectCountry = async (endpoint)=>
    ((await axios.get(`${endpoint}/api/1.0/geo/country`)).data?.data?.id) || ''
}

export default Auth;
